import React, { useRef, useState } from "react";
import Arrow_icon from "../../../New_Web_design/Arrow_icon.png";
import ListData from "./ListData";

const faqs = [
  {
    id: 1,
    header: "How do I sign up and create an account on WolfWin?",
    desc: "To sign up and create an account on WolfWin, simply download our app and click on the Sign Up button. Fill in the required information, including your name, email address, and password. Once submitted, you'll receive a confirmation email to verify your account.",
  },
  {
    id: 2,
    header: "What types of skill-based games are available on WolfWin?",
    desc: "WolfWin offers a diverse range of skill-based games to cater to various interests and preferences. You can enjoy strategy games, puzzle games, trivia quizzes, and more. We constantly update our game library to provide you with new and exciting challenges.",
  },
  {
    id: 3,
    header: "How does the entry fee and cash reward system work?",
    desc: "To participate in a skill-based game on WolfWin, players are required to pay a small entry fee. Entry fee is not a part of prize pool and does not determine the size of prize pool. The more you excel in the game, the higher your chances of winning a substantial cash prize.",
  },
  {
    id: 4,
    header: "Is it legal to play skill-based games for real money on WolfWin?",
    desc: "Yes, playing skill-based games for real money on WolfWin is legal in the jurisdictions where we operate. We have legal opinions from the most experienced lawyers. Additionally, we have statistical analysis for each game, certifying that each of our games is indeed a skill-based game. We ensure compliance with applicable laws and regulations to provide a secure and legitimate gaming experience.",
  },
  {
    id: 5,
    header: "What payment methods are accepted on the platform?",
    desc: "WolfWin accepts majority of popular payment methods including credit cards, debit cards, net banking options, UPI, Paytm, Google Play, PayPal, RuPay, and many more.",
  },
  {
    id: 6,
    header: "How secure is my personal and financial information on WolfWin?",
    desc: "At WolfWin, we take the security of your personal and financial information seriously. We utilize advanced encryption protocols and industry-standard security measures to safeguard your data. On top of that, our platform is regularly audited and monitored to maintain the highest level of data protection.",
  },
  {
    id: 7,
    header: "Are there any age restrictions for playing on WolfWin?",
    desc: "Yes, to comply with legal requirements and ensure responsible gaming, you must be at least 18 years old to play skill-based games on WolfWin. We have age verification processes in place to maintain a safe and secure environment for all users.",
  },
  {
    id: 8,
    header: "Can I play on WolfWin from any location?",
    desc: "WolfWin is accessible to players from various locations, but availability may be subject to local laws and regulations. We strive to expand our reach to accommodate as many players as possible while adhering to legal requirements.",
  },
  {
    id: 9,
    header: "	What happens if there is a technical issue during a game?",
    desc: "In the event of a technical issue during a game, our dedicated support team is available to assist you. You can reach out to us via our support channels, and we'll promptly investigate and resolve any technical issues to ensure a fair and seamless gaming experience.",
  },
  {
    id: 10,
    header: "How are winners determined in skill-based games?",
    desc: "Winners in skill-based games on WolfWin are determined based on their performance and skills. Our games are designed to reward players who demonstrate exceptional abilities and strategic thinking. The highest-scoring or top-ranking players will be declared the winners and receive the corresponding cash rewards.",
  },
  {
    id: 11,
    header:
      "Are there any restrictions on withdrawals and cashing out winnings?",
    desc: "At WolfWin, we prioritize a hassle-free and user-friendly withdrawal process. You can effortlessly request a withdrawal of your winnings and enjoy swift transaction times. Please note that a minimum withdrawal threshold of $100 is in place to ensure efficient processing and security.",
  },
  {
    id: 12,
    header: "Is there a limit on the number of games I can play per day?",
    desc: "We do not impose a specific limit on the number of games you can play per day. You are free to enjoy our skill-based games as much as you like, based on your availability and preferences.",
  },
  {
    id: 13,
    header:
      "Are there any rewards or bonuses for referring friends to WolfWin?",
    desc: "Yes, we value our players and encourage them to invite their friends to join WolfWin. We offer referral programs and bonuses where both you and your referred friends can receive rewards or bonuses when they sign up and start playing on our platform. ",
  },
  {
    id: 14,
    header: "What happens if there is a dispute or disagreement during a game?",
    desc: "In the rare event of a dispute or disagreement during a game, we have a fair and transparent dispute resolution process in place. Our dedicated support team will thoroughly investigate the matter and make a decision based on the available evidence and our platform's policies.",
  },
  {
    id: 15,
    header: "Can I play skill-based games on WolfWin using a mobile device?",
    desc: "Absolutely! WolfWin is designed to be fully compatible with mobile devices, including smartphones and tablets. You can enjoy our skill-based games on the go, allowing for a convenient and flexible gaming experience.",
  },
  {
    id: 16,
    header: "How often are new games added to the WolfWin platform?",
    desc: "We are committed to providing our players with a fresh and engaging gaming experience. We regularly add new skill-based games to our platform, ensuring that you always have exciting and challenging options to explore.",
  },
  {
    id: 17,
    header:
      "What if I encounter an issue or have a question that is not covered in the FAQ section?",
    desc: "If you encounter an issue or have a question that is not covered in the FAQ section, we encourage you to reach out to our support team. You can contact us through our dedicated support channels, and we'll be more than happy to assist you.",
  },
  {
    id: 18,
    header:
      "Can I change my username or profile information after creating an account?",
    desc: "Yes, you can change your username or update your profile information after creating an account. Simply access your account settings and make the desired changes. Please note that certain restrictions or verification processes may apply for security purposes.",
  },
  {
    id: 19,
    header:
      "How can I provide feedback or suggestions for improving the WolfWin platform?",
    desc: "We value your feedback and suggestions to enhance the WolfWin platform. You can provide your feedback through our website's dedicated feedback form or contact our support team directly. Your input is important to us as we continually strive to improve the user experience.",
  },
];

const AccordionItem = (props) => {
  const contentEl = useRef();
  const { handleToggle, active, faq } = props;
  const { header, id, desc } = faq;

  return (
    <div className="">
      <div className="rc-accordion-header">
        <div
          className={`rc-accordion-toggle p-3 ${active === id ? "active" : ""}`}
          onClick={() => handleToggle(id)}
        >
          <p
            style={{
              color: "white",
              fontFamily: "Nunito",
            }}
            className="fontFaqs"
          >
            {header}
          </p>
          {active === id ? (
            <img src={Arrow_icon} />
          ) : (
            <img src={Arrow_icon} className="downArrow" />
          )}
        </div>
      </div>
      <div
        ref={contentEl}
        className={`rc-collapse ${active === id ? "show" : ""}`}
        style={
          active === id
            ? { height: contentEl.current.scrollHeight }
            : { height: "0px" }
        }
      >
        <div className="rc-accordion-body">
          <p
            className="faqcontant mb-0"
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
              fontSize: "20px",
            }}
          >
            {desc}
          </p>
        </div>
      </div>
      <div
        style={{
          borderBottom: "3px solid #1e2128",
        }}
      ></div>
    </div>
  );
};

export default function FaqPage() {
  const [dataLenght, setDataLength] = React.useState(5);
  console.log("dataLenght1::: ", dataLenght);

  const [active, setActive] = useState(null);

  const handleToggle = (index) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };
  return (
    <>
      <div
        className={`${
          window.location.pathname.split("/")[1] == "Faq"
            ? "Homemargin"
            : "mt-5"
        }`}
      >
        <div style={{ height: "100px" }} className="p-3 ">
          <div
            className="d-flex "
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              className="header mb-0 "
              style={{
                fontFamily: "NunitoBlack",

                color: "white",
              }}
            >
              FAQ
            </p>
          </div>
          <div
            className="d-flex"
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <p
              className="sub-header"
              style={{
                color: "#929498",
                fontFamily: "JosefinSans",
              }}
            >
              Frequently Asked Question
            </p>
          </div>
        </div>
        <div>
          <div className="container p-3 mt-4">
            <div
              style={{ border: "3px solid #929498", borderRadius: "25px" }}
              className="p-2"
            >
              {/* {faqList.slice(0, dataLenght).map((item, i) => (
                // <ListData item={item} />
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey={i.toString()}>
                    <Accordion.Header>{ item.header}</Accordion.Header>
                    <Accordion.Body>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                  </Accordion.Item>
                 
                </Accordion>
              ))} */}

              {faqs.slice(0, dataLenght).map((faq, index) => {
                return (
                  <AccordionItem
                    key={index}
                    active={active}
                    handleToggle={handleToggle}
                    faq={faq}
                  />
                );
              })}

              <div
                style={{ display: "flex", justifyContent: "center" }}
                className="my-3"
              >
                {dataLenght == 20 ? (
                  <button
                    className="faqbutton"
                    onClick={() => {
                      setDataLength(5);

                      console.log("dataLenght2::: ", dataLenght);
                    }}
                  >
                    Show less{" "}
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-caret-up"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.204 11h9.592L8 5.519 3.204 11zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659z" />
                      </svg>
                    </span>
                  </button>
                ) : (
                  <>
                    <button
                      className="faqbutton"
                      onClick={() => {
                        if (dataLenght == 20) {
                        } else {
                          setDataLength(dataLenght + 5);
                        }

                        console.log("dataLenght2::: ", dataLenght);
                      }}
                    >
                      Show More{" "}
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-caret-down"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3.204 5h9.592L8 10.481 3.204 5zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659z" />
                        </svg>
                      </span>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
